import { a1 as attr, P as pop, N as push } from "../../../chunks/index.js";
import { U as UpcomingEvents, S as SocialMediaIcons } from "../../../chunks/UpcomingEvents.js";
function _page($$payload, $$props) {
  push();
  let { data } = $$props;
  if (data.showUpcoming) {
    $$payload.out += "<!--[-->";
    UpcomingEvents($$payload);
  } else if (data.event) {
    $$payload.out += "<!--[1-->";
    if (data.event.cancelled === true) {
      $$payload.out += "<!--[-->";
      $$payload.out += `<main style="background-color: #f8f8f6; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 80vh;"><div style="text-align: center;"><h1 style="font-size: 2.5rem; color: #b00020; margin-bottom: 1rem; font-family: 'Georgia', serif;">This Event Has Been Cancelled</h1> <p style="font-size: 1.5rem; color: #666; font-family: 'Georgia', serif;">We apologize for any inconvenience. Please check back for future events.</p></div></main>`;
    } else {
      $$payload.out += "<!--[!-->";
      $$payload.out += `<main style="background-color: #f8f8f6; display: flex; flex-direction: column; align-items: center; justify-content: top;"><img${attr("src", data.event.tmpFlyer)}${attr("alt", data.event.name + " Flyer")} style="max-width: 90%; height: auto; width: 45em; box-shadow: 0 4px 24px rgba(0,0,0,0.12); border-radius: 1rem; border: 2px black solid; margin-top: 1rem;"/> <br/> `;
      SocialMediaIcons($$payload);
      $$payload.out += `<!----></main>`;
    }
    $$payload.out += `<!--]-->`;
  } else {
    $$payload.out += "<!--[!-->";
    $$payload.out += `<main style="background-color: #f8f8f6; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 80vh;"><p style="font-size: 1.5rem; color: #666;">Event not found</p></main>`;
  }
  $$payload.out += `<!--]-->`;
  pop();
}
export {
  _page as default
};
